import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  id?: string;
};
export function CTAButton({
  label,
  id
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className="group mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-cta-ink shadow-[0_6px_0_0_#C99700] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[4px] active:shadow-[0_2px_0_0_#C99700] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-400 sm:text-lg" data-id="element-95" data-mp="2kzfz1bppoqft">
      <span className="text-balance" data-id="element-96" data-mp="3cpkr7wjpqhrl">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-97" data-mp="3cqdnu4oyjqw0" />
    </a>;
}